import fetch from "auth/FetchInterceptor";

const CompanyPhoneService = {};

CompanyPhoneService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/company-phone",
		method: "get",
		params,
	});
};

CompanyPhoneService.post = function (data) {
	return fetch({
		url: "/v1/rest/company-phone",
		method: "post",
		data: data,
	});
};

CompanyPhoneService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/company-phone/${id}`,
		method: "put",
		data: data,
	});
};

CompanyPhoneService.getById = function (id) {
	return fetch({
		url: `/v1/rest/company-phone/${id}`,
		method: "get",
	});
};

export default CompanyPhoneService;
